export default "__VITE_ASSET__DpVh0yWe__"